import { render, staticRenderFns } from "./TankAttr.vue?vue&type=template&id=1a5c0a19&scoped=true&"
import script from "./TankAttr.vue?vue&type=script&lang=js&"
export * from "./TankAttr.vue?vue&type=script&lang=js&"
import style0 from "./TankAttr.vue?vue&type=style&index=0&id=1a5c0a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c0a19",
  null
  
)

export default component.exports